var _rect, _mask, _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    width: 48,
    height: 48,
    rx: 5,
    transform: "rotate(90 54 0)",
    fill: "#0CBFE7"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 10,
    width: 28,
    height: 28
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 10,
    width: 28,
    height: 28,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.407 25.1667C24.3378 25.1667 25.1745 24.2015 25.1745 23.0738C25.1745 21.5906 23.7439 21.2459 22.5602 20.9607C21.7249 20.7594 21.0125 20.5877 21.0125 20.0665C21.0125 19.5585 21.4845 19.2233 22.2246 19.2233C22.9755 19.2233 23.7371 19.4671 24.2949 19.9954L25.0136 19.1115C24.3485 18.5019 23.4475 18.1667 22.3319 18.1667C20.7658 18.1667 19.7253 19.0302 19.7253 20.1478C19.7253 21.5724 21.081 21.8978 22.2469 22.1776C23.1265 22.3887 23.898 22.5739 23.898 23.1855C23.898 23.6326 23.4904 24.1101 22.4606 24.1101C21.463 24.1101 20.6907 23.6732 20.1972 23.1754L19.5 24.0897C20.1329 24.7298 21.0876 25.1667 22.407 25.1667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.764 25.0448V18.2683H31.9941L30.0418 22.7284L28.1002 18.2683H26.3303V25.0448H27.5853V20.0157L29.7736 25.0448H30.3099L32.5089 20.0157V25.0448H33.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 23.0738C40.5 24.2015 39.6633 25.1667 37.7325 25.1667C36.4131 25.1667 35.4584 24.7298 34.8255 24.0897L35.5228 23.1754C36.0162 23.6732 36.7885 24.1101 37.7861 24.1101C38.8159 24.1101 39.2235 23.6326 39.2235 23.1855C39.2235 22.5739 38.452 22.3887 37.5724 22.1776C36.4065 21.8978 35.0508 21.5724 35.0508 20.1478C35.0508 19.0302 36.0913 18.1667 37.6574 18.1667C38.773 18.1667 39.674 18.5019 40.3391 19.1115L39.6204 19.9954C39.0626 19.4671 38.301 19.2233 37.5501 19.2233C36.81 19.2233 36.338 19.5585 36.338 20.0665C36.338 20.5877 37.0504 20.7594 37.8857 20.9607C39.0694 21.2459 40.5 21.5906 40.5 23.0738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6667 33.3333H27.8433L20.9902 37.902C20.8112 38.0214 20.5811 38.0325 20.3914 37.931C20.2017 37.8295 20.0833 37.6318 20.0833 37.4167V33.3333H18.3333C17.0447 33.3333 16 32.2887 16 31V12.3333C16 11.0447 17.0447 10 18.3333 10H41.6667C42.9553 10 44 11.0447 44 12.3333V31C44 32.2887 42.9553 33.3333 41.6667 33.3333ZM18.3333 11.1667H41.6667C42.311 11.1667 42.8333 11.689 42.8333 12.3333V31C42.8333 31.6443 42.311 32.1667 41.6667 32.1667H27.3485L26.5557 32.7895L21.25 36.3267V32.1667H18.3333C17.689 32.1667 17.1667 31.6443 17.1667 31V12.3333C17.1667 11.689 17.689 11.1667 18.3333 11.1667Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 24C60 27.3137 57.3137 30 54 30C50.6863 30 48 27.3137 48 24C48 20.6863 50.6863 18 54 18C57.3137 18 60 20.6863 60 24Z",
    fill: "#9088DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 29C56.7614 29 59 26.7614 59 24C59 21.2386 56.7614 19 54 19C51.2386 19 49 21.2386 49 24C49 26.7614 51.2386 29 54 29ZM54 30C57.3137 30 60 27.3137 60 24C60 20.6863 57.3137 18 54 18C50.6863 18 48 20.6863 48 24C48 27.3137 50.6863 30 54 30Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C12 27.3137 9.31371 30 6 30C2.68629 30 0 27.3137 0 24C0 20.6863 2.68629 18 6 18C9.31371 18 12 20.6863 12 24Z",
    fill: "#9088DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 29C8.76142 29 11 26.7614 11 24C11 21.2386 8.76142 19 6 19C3.23858 19 1 21.2386 1 24C1 26.7614 3.23858 29 6 29ZM6 30C9.31371 30 12 27.3137 12 24C12 20.6863 9.31371 18 6 18C2.68629 18 0 20.6863 0 24C0 27.3137 2.68629 30 6 30Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsPreview);
export default __webpack_public_path__ + "static/media/SMSPreview.7e8231624cfe4bbc54df86330301610d.svg";
export { ForwardRef as ReactComponent };